module.exports = __webpack_public_path__ + "img/about-position-sustainable-packaging.svg?83ce30d558ed87c1ae1922d667d8b487";